import type { ProfessionalTypeEnum } from '@gql/graphql';
import type { LocationDescriptor } from 'history';
import type { ReactNode } from 'react';
import type { JoinProInfoPageType } from '..';

export interface JoinProPageFormValues {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export interface JoinProPageData {
  formComponent: ReactNode;
  links: Record<JoinProInfoPageType, LocationDescriptor>;
}

export interface JoinProPageProps extends JoinProPageData {
  type: ProfessionalTypeEnum;
}
